import { useState } from 'react'

import { DataItem } from 'scrivito'

import {
  buildAllTimesFilters,
  filterRecordsForView,
  shouldPaginate,
} from './recordsScope'
import { NO_LIMIT } from '../../const'
import { WeekRange, FilterValues } from '../../types'
import { Timerecord } from '@/Data/Timerecord/TimerecordDataClass'
import { dataScopeHasMore } from '@/utils/dataScopeHasMore'

const PAGE_SIZE = 50

type AllTimesData = {
  timeRecordItems: DataItem[]
  hasMore: boolean
  loadMore: () => void
}

export const useAllTimesData = (
  appliedFilters: FilterValues,
  externalWeekRange: WeekRange,
): AllTimesData => {
  const [limit, setLimit] = useState(PAGE_SIZE)

  const filters = buildAllTimesFilters(appliedFilters, externalWeekRange)
  const order: [string, 'desc'][] = [['recordedAt', 'desc']]
  const isPaginated = shouldPaginate(appliedFilters)

  const records = Timerecord.all()
    .transform({ filters, order, ...(isPaginated ? { limit } : NO_LIMIT) })
    .take()

  const timeRecordItems = filterRecordsForView(records, appliedFilters)

  const hasMore =
    isPaginated && dataScopeHasMore(Timerecord.all(), { filters, order }, limit)

  const loadMore = () => {
    setLimit((prev) => prev + PAGE_SIZE)
  }

  return { timeRecordItems, hasMore, loadMore }
}
